export default "__VITE_ASSET__DmV2$Ooe__"